import React, { Component } from 'react';

import VehicleTab from './VehicleTab';

export default VehicleTab;
